define(function(require) {

    const _ = require('underscore');
    const RegistrationView = require('portlets/registration/registration.view');

    return RegistrationView.extend({
        events: function() {
            return _.extend({}, RegistrationView.prototype.events, {
                'input .field-group_name_date select': 'handleBirthdayChange',
                'input .field_name_personalId input': 'handlePersonalIdChange'
            });
        },

        handleBirthdayChange: function() {
            const value = this.$('.field_name_personalId input').val();
            const [yy, mm, dd] = value.slice(0, 8).split('.');

            const year = this.$('.field_name_year select').val().slice(-2) || yy;
            const month = this.$('.field_name_month select').val() || mm;
            const day = this.$('.field_name_day select').val() || dd;

            // mask in format "yy.mm.dd"
            const mask = [year, month, day].join('.');

            this.$('.field_name_personalId input').val(value.replace(value.slice(0, 8), mask));
        },

        handlePersonalIdChange: function(e) {
            // mask in format "yy.mm.dd-xxx.cd"
            const mask = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,3})(\d{0,2})/);
            const [, yy, mm, dd, xxx, cd] = mask;

            const birthdate = _.compact([yy, mm, dd]);
            const xxxcd = _.compact([xxx, cd]);

            e.target.value = _.compact([birthdate.join('.'), xxxcd.join('.')]).join('-');

            const date = new Date();
            const year = yy >= date.getFullYear().toString().slice(-2) ? '19' + yy : '20' + yy;

            this.$('.field_name_year select').val(year).trigger('change');
            this.$('.field_name_month select').val(mm).trigger('change');
            this.$('.field_name_day select').val(dd).trigger('change');
        }
    });
});
